// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { orderSummaryCardStyles } from "@sc/Overrides/Components/OrderSummaryCard";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

orderSummaryCardStyles.actionsCells = {
    css: css`
        min-width: 105px;
        max-width: 160px;
        text-align: center;
    `,
};

orderSummaryCardStyles.reorderButton = {
    variant: "tertiary",
    sizeVariant: "medium",
    icon: {
        src: "RefreshCcw",
        position: "left",
    },
    css: css`
        width: 100%;
    `,
};

orderSummaryCardStyles.reorderButtonSpinner = {
    size: 20,
    color: "primary",
};

orderSummaryCardStyles.dataCells = {
    css: css`
        ${TypographyStyle} {
            color: ${color("text.main")};
            font-weight: normal;
            &:hover {
                color: ${color("text.main")};
            }
        }
    `,
};
